import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorFavoritesState = (state: RootState) => state.favorites;

export const selectorFavorites = createSelector(
  selectorFavoritesState,
  (favoritesState) => favoritesState
);
